// extracted by mini-css-extract-plugin
export default {"logo":"CompleteInfo_logo__UEV3y"};